import { FlightRoomUser } from './flightRoomUser';

export type Channel = {
  description: string;
  firstUnreadMessage: string | null;
  hasUnreadMentions: boolean;
  id: string;
  title: string;
  totalMessagesCount?: number;
  type: ChannelType;
  unreadMessagesCount: number;
  users: FlightRoomUser[];
};

export enum ChannelType {
  PRIVATE = 'private',
  PUBLIC = 'public',
}
